export default "__VITE_ASSET__6d0fe80c__"